import * as React from 'react';
import {Mutation} from 'react-apollo';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import gql from 'graphql-tag';
import type Moment from 'moment';
import moment from 'moment';
import AutoSizer from 'react-virtualized/dist/es/AutoSizer';
import InfiniteLoader from 'react-virtualized/dist/es/InfiniteLoader';
import List from 'react-virtualized/dist/es/List';
import _ from 'underscore';

import * as Leads from 'nutshell-core/leads';

import {DateHeader} from 'shells/date-header/date-header';
// @ts-expect-error - imported from .js/.jsx file
import {TodoEmptyStateIcon} from 'shells/icon/svg/todo-empty-state-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TodoErrorStateIcon} from 'shells/icon/svg/todo-error-state-icon';
import {TodoListItem} from 'shells/list-item/todo-list-item';
// @ts-expect-error - imported from .js/.jsx file
import {ListRowLoading} from 'shells/list-row/list-row-loading';
import {ListViewInfiniteLoading} from 'shells/list-view/list-view-infinite-loading';
import {SidebarSpecialState} from 'shells/sidebar-special-state/sidebar-special-state';

import type {
    SkipStepInputFieldInput,
    SkipStepMutation as SkipStepMutationMutation,
    SkipStepMutationVariables as SkipStepMutationMutationVariables,
    CompleteStepInputFieldInput,
    CompleteStepMutation as CompleteStepMutationMutation,
    CompleteStepMutationVariables as CompleteStepMutationMutationVariables,
} from 'nutshell-graphql-types';

import type {NutshellState} from '../../../../../../store';
import {openComposerWithId} from '../../../../../email/email-composer-actions';
// @ts-expect-error
import * as actions from '../../../../dashboard-actions';
// @ts-expect-error
import * as dashboardSelectors from '../../../../dashboard-selectors';

import {PAST, TODAY, TOMORROW, FUTURE} from '../../todos-constants';
// @ts-expect-error
import * as selectors from '../../todos-selectors';

import type {TodoPeriodSegment} from '../todo-list-controls/todo-list-controls';

import styles from './todo-list.module.css';

const ROWS_TO_FETCH = 50;
const LOADING_LINES_HEIGHT = 104;
const LIST_HEADER_HEIGHT = 40;
const TODO_HEIGHT = 56;
const CREATOR_ENTITY_HEIGHT = 18;

const STEP = gql`
    fragment TodoListStep on Step {
        id
        type
        title
        href
        description
        delayApplications {
            id
        }
        dueTime
        isCompleteable
        isCompleted
        isDelayable
        isOverdue
        isSkippable
        isSkipped
        requirementText
        relatedLead {
            id
        }
    }
`;

const COMPLETE_STEP = gql`
    mutation CompleteStepMutation($step: CompleteStepInputFieldInput!) {
        completeStep(input: {step: $step}) {
            step {
                ...TodoListStep
            }
            nextStep {
                ...TodoListStep
            }
        }
    }
    ${STEP}
`;

const SKIP_STEP = gql`
    mutation SkipStepMutation($step: SkipStepInputFieldInput!) {
        skipStep(input: {step: $step}) {
            step {
                ...TodoListStep
            }
            nextStep {
                ...TodoListStep
            }
        }
    }
    ${STEP}
`;

const mapStateToProps = function (state: NutshellState): StateProps {
    return {
        todos: selectors.getTodoList(state),
        todoTotalCount: selectors.getTodoTotalCount(state),
        currentScrollIndex: selectors.getTodoListScrollIndex(state),
        displayDate: selectors.getDisplayDate(state),
        activePeriodSegment: selectors.getActivePeriodSegment(state),
        periodSegmentWasManuallySelected: selectors.getPeriodSegmentWasManuallySelected(state),
        filters: selectors.getFilter(state),
        queryString: selectors.getQueryString(state),
        hasError: Boolean(selectors.getListErrorMessage(state)),
        isRequesting: selectors.getIsRequesting(state),
        sidebarWidth: dashboardSelectors.getRightPaneWidth(state),
        leadsById: Leads.getById(state),
    };
};

// @ts-expect-error
const mapDispatchToProps = function (dispatch): DispatchProps {
    return {
        onDisplayDateChange: (timestamp) => {
            const dateFromTimestamp = new Date(timestamp);
            dispatch(actions.updateTodoDisplayDate(dateFromTimestamp));
        },
        onTodoPeriodSegmentSelected: (period) => {
            dispatch(actions.updateTodoPeriodSegmentSelected(period));
            dispatch(actions.updatePeriodSegmentWasManuallySelected(false));
        },
        onUpdateDueTime: (task, newDate) => {
            actions.updateDueTime(dispatch, task, newDate);
        },
        onDelay: (step, delayId) => {
            actions.delayStep(dispatch, step, delayId);
        },
        onUpdateStep: (step) => {
            dispatch(actions.updateTodoDataById(step));
        },
        onCompleteTask: (task) => {
            dispatch(actions.completeTask(task));
        },
        onUncomplete: (model) => {
            actions.uncompleteTodo(dispatch, model);
        },
        onClearError: (model) => {
            dispatch(actions.clearTodoErrorById(model.id));
        },
        onClearTodoListError: () => {
            dispatch(actions.clearTodoListError());
        },
        onFetchMoreRows: (startIndex, endIndex) => {
            return dispatch(actions.fetchTodosByIndex(startIndex, endIndex));
        },
        onStartEmailToEntity: (entityId) => {
            dispatch(openComposerWithId(entityId));
        },
        fetchRelatedLead: (leadId) => {
            dispatch(Leads.fetchLeadById(leadId));
        },
        resetToToday: () => {
            dispatch(actions.updateTodoPeriodSegmentSelected(TODAY));
            dispatch(actions.updatePeriodSegmentWasManuallySelected(true));
        },
    };
};

type StateProps = {
    todos: any[];
    todoTotalCount: number;
    currentScrollIndex: number;
    // @ts-expect-error
    displayDate: Moment;
    activePeriodSegment: TodoPeriodSegment;
    periodSegmentWasManuallySelected: boolean;
    filters: string;
    queryString: string;
    hasError: boolean | null | undefined;
    isRequesting: boolean;
    sidebarWidth: number;
    leadsById: any;
};

type DispatchProps = {
    onFetchMoreRows: (startIndex?: number, endIndex?: number) => any;
    onDisplayDateChange: (timestamp: number) => void;
    onTodoPeriodSegmentSelected: (newSegment: TodoPeriodSegment) => void;
    // @ts-expect-error
    onUpdateDueTime: (todo: any, date: Moment) => void;
    onDelay: (todo: any, delayId: string) => void;
    onUpdateStep: (todo: any) => void;
    onCompleteTask: (todo: any) => void;
    onUncomplete: (todo: any) => void;
    onClearError: (todo: any) => void;
    onClearTodoListError: () => void;
    onStartEmailToEntity: (entityId: string) => void;
    fetchRelatedLead: (leadId: string) => void;
    resetToToday: () => void;
};

type GraphQLProps = {
    onCompleteStep: (arg1: CompleteStepInputFieldInput) => Promise<any>;
    onSkip: (arg1: SkipStepInputFieldInput) => Promise<any>;
};

type RoutedProps = GraphQLProps & ContextRouter;

type Props = RoutedProps & StateProps & DispatchProps;

type State = {
    hasFinishedFirstLoad: boolean;
    scrollIndexToJumpTo?: number;
};

export class TodoListComponent extends React.Component<Props, State> {
    list: List | null | undefined;
    topTodoIndex = 0;
    // @ts-expect-error
    totalHeight: number;
    // @ts-expect-error
    rowCount: number;
    // @ts-expect-error
    onRowsRendered: (...args: any) => any;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            hasFinishedFirstLoad: false,
            scrollIndexToJumpTo: undefined,
        };
    }

    componentDidMount() {
        this.loadFirstRows();
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        // Filters were changed, or something else happened that reset the total count,
        // but new todos have not been started to be fetched yet, so we need to
        // fetch them
        if (
            (nextProps.filters !== this.props.filters ||
                nextProps.queryString !== this.props.queryString) &&
            !nextProps.isRequesting &&
            !nextProps.hasError
        ) {
            this.setState({hasFinishedFirstLoad: false});
            this.loadFirstRows();
        }

        if (nextProps.todos !== this.props.todos) {
            // Instruct list to remeasure newly-loaded rows
            if (this.list) {
                this.list.recomputeRowHeights();
            }

            if (typeof this.topTodoIndex !== 'undefined' && nextProps.todos[this.topTodoIndex]) {
                const currentDate = moment(this.props.displayDate);
                const nextTopTodo = nextProps.todos[this.topTodoIndex];
                const nextTopTodoDate =
                    nextTopTodo.type === 'headers'
                        ? moment.unix(nextTopTodo.date)
                        : moment.unix(nextTopTodo.dueTime);

                if (!currentDate.isSame(nextTopTodoDate, 'day')) {
                    this.props.onDisplayDateChange(nextTopTodoDate.valueOf());
                }
            }
        }

        // Check if we've clicked one of the date facets, and jump if necessary
        if (
            nextProps.periodSegmentWasManuallySelected !==
                this.props.periodSegmentWasManuallySelected ||
            nextProps.currentScrollIndex !== this.props.currentScrollIndex
        ) {
            this.maybeJumpToIndex(nextProps);
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.sidebarWidth !== this.props.sidebarWidth && this.list) {
            this.list.recomputeRowHeights();
        }

        // @ts-expect-error
        const nonUndefinedTodos = this.props.todos.filter((todo) => todo).length;
        // @ts-expect-error
        const prevNonUndefinedTodos = prevProps.todos.filter((todo) => todo).length;
        if (nonUndefinedTodos !== prevNonUndefinedTodos && this.list) {
            this.list.recomputeRowHeights();
        }

        // If we finished our first load, we might have to
        if (prevState.hasFinishedFirstLoad !== this.state.hasFinishedFirstLoad) {
            this.maybeJumpToIndex(this.props);
        }
    }

    render() {
        const headerCount = this.props.todos.filter(
            // @ts-expect-error
            (todo) => todo && todo.type === 'headers'
        ).length;
        this.rowCount =
            this.state.hasFinishedFirstLoad || this.props.todoTotalCount > 0
                ? this.props.todoTotalCount + headerCount + 1 // Add a row for blank padding at the end
                : 1;

        // We add a blank row at the bottom so the list can be scrolled all the way down,
        // but we don't want this row to be added to the list if there are _no_
        // items in the list, so we'll correct that number here.
        const realRowCountForList = this.rowCount === 1 ? 0 : this.rowCount;

        return (
            <div className={styles['todo-scroll-container']}>
                {this.props.hasError || !this.state.hasFinishedFirstLoad
                    ? this.renderOverlay()
                    : undefined}
                <InfiniteLoader
                    isRowLoaded={this.isRowLoaded}
                    loadMoreRows={this.loadMoreRows}
                    minimumBatchSize={ROWS_TO_FETCH}
                    threshold={0}
                    rowCount={this.rowCount}
                >
                    {({onRowsRendered}) => {
                        this.onRowsRendered = onRowsRendered;

                        return (
                            <AutoSizer onResize={this.handleResize}>
                                {({height, width}) => {
                                    this.totalHeight = height;

                                    return (
                                        <List
                                            ref={(c) => {
                                                this.list = c;
                                            }}
                                            height={height}
                                            width={width}
                                            relatedLeads={this.props.leadsById}
                                            rowCount={realRowCountForList}
                                            rowHeight={this.getRowHeightForCell}
                                            overscanRowCount={5}
                                            rowRenderer={this.renderRow}
                                            onRowsRendered={this.handleRowsRendered}
                                            noRowsRenderer={this.noRowsRenderer}
                                            scrollToAlignment='start'
                                            scrollToIndex={this.state.scrollIndexToJumpTo}
                                        />
                                    );
                                }}
                            </AutoSizer>
                        );
                    }}
                </InfiniteLoader>
            </div>
        );
    }

    /**
     * Fixed-height todo-items give the best performance, so that's what we're using.
     * but we still need to deal with the final row (which we can size larger to allow the header
     * to float all the way to the top), and headers.
     *
     * @param  {Object} index - rowIndex used to determine To do height
     * @return {number}           calculated height of To do
     */
    getRowHeightForCell = ({index}: {index: number}) => {
        // Recursive way to get the height of the last row, which allows the
        // list to scroll past the last To do, so that the final day's header
        // is at the top of the list.
        if (index === this.rowCount - 1) {
            let finalDayHeight = this.totalHeight;
            const prevTodo = this.props.todos[index - 1];
            if (prevTodo) {
                const lastTodoDate = prevTodo.dueTime
                    ? moment.unix(prevTodo.dueTime)
                    : moment().endOf('day');
                const previousDateHeaderIndex = this.findDayHeaderIndex(lastTodoDate);
                const finalDayRows = _.range(previousDateHeaderIndex, this.rowCount - 1);
                finalDayHeight = finalDayRows.reduce((height, rowIndex) => {
                    const rowHeight = this.getRowHeightForCell({index: rowIndex});

                    return height + rowHeight;
                }, 0);
            }

            return Math.max(this.totalHeight - finalDayHeight, 0);
        }

        // Loading rows
        if (!this.isRowLoaded({index})) {
            return this.rowCount === 1
                ? LOADING_LINES_HEIGHT // Initial "first-load" row
                : TODO_HEIGHT; // Empty to do items
        }

        const todo = this.props.todos[index];

        if (todo.type === 'headers') {
            return LIST_HEADER_HEIGHT;
        }

        if (NutClientConfig.hasAiFollowUpTasksFF && todo.creatorEntity) {
            return TODO_HEIGHT + CREATOR_ENTITY_HEIGHT;
        }

        return TODO_HEIGHT;
    };

    renderRow = ({key, style, index}: {key: string; style: any; index: number}) => {
        // The final row should be blank padding
        if (index === this.rowCount - 1) {
            let finalDayHeight = this.totalHeight;
            const prevTodo = this.props.todos[index - 1];
            if (prevTodo) {
                const previousDateHeaderIndex = this.findDayHeaderIndex(
                    moment.unix(prevTodo.dueTime)
                );
                const finalDayRows = _.range(previousDateHeaderIndex, this.rowCount - 1);
                finalDayHeight = finalDayRows.reduce((height, rowIndex) => {
                    const rowHeight = this.getRowHeightForCell({index: rowIndex});

                    return height + rowHeight;
                }, 0);
            }

            return (
                <div
                    key={key}
                    style={{
                        ...style,
                        height: this.totalHeight - finalDayHeight,
                    }}
                />
            );
        }

        if (!this.isRowLoaded({index})) {
            return this.rowCount === 1 ? (
                <ListViewInfiniteLoading />
            ) : (
                <ListRowLoading key={key} style={style} hasCheckbox={true} />
            );
        }

        const todo = this.props.todos[index];

        if (todo.type === 'headers') {
            return <DateHeader key={key} style={style} date={todo.date} />;
        }

        return (
            <TodoListItem
                key={key}
                style={style}
                todo={todo}
                leadModel={
                    todo.relatedEntity && todo.relatedEntity.type === 'leads'
                        ? this.props.leadsById[todo.relatedEntity.id]
                        : undefined
                }
                onTimeChange={this.props.onUpdateDueTime}
                onEdit={this.handleEditTask}
                onDelete={this.handleDeleteTask}
                onClearError={this.props.onClearError}
                onDelayConfirm={this.props.onDelay}
                onSkipConfirm={this.handleSkip}
                onComplete={this.handleComplete}
                onUncompleteConfirm={this.props.onUncomplete}
                onStartCallToEntity={this.handleStartCallToParticipant}
                onStartEmailToEntity={this.props.onStartEmailToEntity}
                fetchRelatedLead={this.props.fetchRelatedLead}
            />
        );
    };

    handleComplete = (todo: any) => {
        if (todo.type === 'tasks') this.props.onCompleteTask(todo);
        else if (todo.type === 'steps') {
            // @ts-expect-error
            this.props.onCompleteStep(todo).then((fetchResult) => {
                if (!fetchResult) return;
                const {data} = fetchResult;
                if (data && data.completeStep && data.completeStep.step) {
                    const completedStep = {...data.completeStep.step} as const;

                    if (data.completeStep.nextStep) {
                        const nextStep = {...data.completeStep.nextStep} as const;
                        completedStep.nextStepId = nextStep.id;

                        // This should really always be the case, but let's be sure
                        if (todo.relatedEntity.id === nextStep.relatedLead.id) {
                            nextStep.relatedEntity = todo.relatedEntity;
                        }

                        this.props.onUpdateStep(nextStep);
                    }

                    this.props.onUpdateStep(completedStep);
                }
            });
        }
    };

    handleSkip = (todo: any) => {
        // @ts-expect-error
        this.props.onSkip(todo).then((fetchResult) => {
            if (!fetchResult) return;
            const {data} = fetchResult;

            if (data && data.skipStep && data.skipStep.step) {
                const skippedStep = {...data.skipStep.step} as const;

                if (data.skipStep.nextStep) {
                    const nextStep = {...data.skipStep.nextStep} as const;
                    skippedStep.nextStep = nextStep.id;

                    // This should really always be the case, but let's be sure
                    if (todo.relatedEntity.id === nextStep.relatedLead.id) {
                        nextStep.relatedEntity = todo.relatedEntity;
                    }

                    this.props.onUpdateStep(nextStep);
                }

                this.props.onUpdateStep(skippedStep);
            }
        });
    };

    handleEditTask = (todo: any) => {
        this.props.history.replace({
            pathname: `${todo.htmlUrlPath}/edit`,
            state: {
                modal: true,
            },
        });
    };

    handleDeleteTask = (todo: any) => {
        $.ajax({
            type: 'DELETE',
            url: todo.href,
        }).then(() => this.props.onFetchMoreRows());
    };

    renderOverlay() {
        return (
            <div className={styles['empty-loading']}>
                {this.props.hasError ? (
                    <SidebarSpecialState
                        iconComponent={<TodoErrorStateIcon size={100} />}
                        headerText='Whoops!'
                        subheaderText={"That didn't quite go to plan"}
                        primaryCTA={{
                            ctaText: 'Try again',
                            onClick: this.props.onClearTodoListError,
                        }}
                    />
                ) : (
                    <ListViewInfiniteLoading />
                )}
            </div>
        );
    }

    handleRowsRendered = (indicies: {startIndex: number; stopIndex: number}) => {
        const {startIndex} = indicies;
        if (this.props.todos[startIndex]) {
            if (this.topTodoIndex && this.topTodoIndex === startIndex) {
                this.onRowsRendered(indicies);

                return;
            }

            // Wait for first load to finish before starting to move things around
            if (!this.state.hasFinishedFirstLoad) {
                this.onRowsRendered(indicies);

                return;
            }

            this.handleNewTopIndex(startIndex);
        }
        this.onRowsRendered(indicies);
    };

    // If we've scrolled to a new row, or jumped there from the date segments, we might need to update
    // some things like the date displayed at the very top, and the selected date segment.
    handleNewTopIndex = (startIndex: number) => {
        this.topTodoIndex = startIndex;
        const todo = this.props.todos[startIndex];
        if (!todo) return;

        const now = moment();
        const yesterday = now.clone().subtract(1, 'day');
        const tomorrow = now.clone().add(1, 'day');
        const dayAfterTomorrow = now.clone().add(2, 'days');

        // We can have todos with no dueTime, so we need to ensure
        // that we're checking for that and manually setting our
        // date to the endOfDay instead of "0" which defaults to
        // December 31st, 1969
        const dueTime = todo.type === 'headers' ? todo.date : todo.dueTime;

        // If we have a dueTime, use its unix value, otherwise
        // just set our date to the end of today
        const date = dueTime ? moment.unix(dueTime) : moment().endOf('day');

        // Change the display date if necessary
        const currentDisplayDate = moment(this.props.displayDate);
        if (!currentDisplayDate.isSame(date, 'day')) {
            this.props.onDisplayDateChange(date.valueOf());
        }

        // Move the period segment indicator if needed
        // This has the side-effect of clearing out periodSegmentWasManuallySelected,
        // which is good, because it prevents us from jumping back to that header when loading
        // more data.
        const {activePeriodSegment} = this.props;
        if (date.isSame(now, 'day') && activePeriodSegment !== TODAY) {
            this.props.onTodoPeriodSegmentSelected(TODAY);
        } else if (date.isSame(tomorrow, 'day') && activePeriodSegment !== TOMORROW) {
            this.props.onTodoPeriodSegmentSelected(TOMORROW);
        } else if (date.isSameOrAfter(dayAfterTomorrow, 'day') && activePeriodSegment !== FUTURE) {
            this.props.onTodoPeriodSegmentSelected(FUTURE);
        } else if (date.isSameOrBefore(yesterday, 'day') && activePeriodSegment !== PAST) {
            this.props.onTodoPeriodSegmentSelected(PAST);
        }
    };

    handleResize = () => {
        // Instruct list to remeasure final row
        if (this.list) {
            this.list.recomputeRowHeights(this.rowCount - 1);
        }
    };

    loadMoreRows = ({startIndex, stopIndex}: {startIndex: number; stopIndex: number}) => {
        // We don't want to make more than one request at a time,
        // We used to try to allow loading multiple when changing assignee filters in case
        // the new user only had overdue filters, but this caused lots of other problems, and is
        // much more of an edge case.
        if (this.props.isRequesting || !this.state.hasFinishedFirstLoad || this.props.hasError) {
            return;
        }

        const headerCount = this.countHeadersBeforeIndex(startIndex);
        const todosStart = startIndex - headerCount;
        const todosStop = stopIndex - headerCount;

        return this.props.onFetchMoreRows(todosStart, todosStop).then(() => {
            // Instruct list to remeasure newly-loaded rows
            if (this.list) {
                this.list.recomputeRowHeights();
            }
        });
    };

    loadFirstRows = () => {
        // The first rows are fetched around TODAY (some before, some after), so if we're
        // fetching first rows, make sure we're looking at today.
        if (this.props.activePeriodSegment !== TODAY) {
            this.props.resetToToday();
        }
        this.props.onFetchMoreRows().then(() => {
            // Instruct list to remeasure newly-loaded rows
            if (this.list) {
                this.list.recomputeRowHeights();
            }

            this.setState({hasFinishedFirstLoad: true});
        });
    };

    maybeJumpToIndex = ({periodSegmentWasManuallySelected, currentScrollIndex}: Props) => {
        const scrollIndexToJumpTo =
            this.state.hasFinishedFirstLoad && periodSegmentWasManuallySelected
                ? currentScrollIndex
                : undefined;
        if (scrollIndexToJumpTo !== this.state.scrollIndexToJumpTo) {
            this.setState({scrollIndexToJumpTo});
            if (typeof scrollIndexToJumpTo !== 'undefined') {
                this.handleNewTopIndex(scrollIndexToJumpTo);
            }
        }
    };

    handleStartCallToParticipant = ({
        entityId,
        phoneNumber,
        anchorElementId,
    }: {
        entityId: string;
        phoneNumber: {
            E164: string;
            numberFormatted: string;
        };
        anchorElementId: string;
    }) => {
        $(window).trigger(Peep.events.showReactClickToCallPopover, {
            entityId,
            anchorElementId,
            rawPhoneNumber: phoneNumber.E164,
            formattedPhoneNumber: phoneNumber.numberFormatted,
        });
    };

    isRowLoaded = ({index}: {index: number}) => {
        // Do not try to fetch final (blank padding) row
        if (index === this.rowCount - 1) {
            return true;
        }

        return Boolean(this.props.todos[index]);
    };

    countHeadersBeforeIndex = (index: number) => {
        const priorItems = this.props.todos.slice(0, index);

        // @ts-expect-error
        return priorItems.filter((item) => {
            return item && item.type === 'headers';
        }).length;
    };

    // @ts-expect-error
    findDayHeaderIndex = (targetDate: Moment) => {
        return _.findIndex(this.props.todos, (todo) => {
            return (
                todo && todo.type === 'headers' && moment.unix(todo.date).isSame(targetDate, 'day')
            );
        });
    };

    noRowsRenderer = () => {
        return (
            <div style={{backgroundColor: '#FDFCFB', height: '100%'}}>
                <SidebarSpecialState
                    headerText='No tasks were found'
                    subheaderText='Tasks are a lightweight way to remind yourself of things you need to do.'
                    iconComponent={<TodoEmptyStateIcon size={70} />}
                    primaryCTA={{
                        ctaText: 'Add a task',
                        to: {hash: '/create/tasks', state: {modal: true}},
                    }}
                />
            </div>
        );
    };
}

// @ts-expect-error
const withRedux = connect<Props, RoutedProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);

// @ts-expect-error
const ConnectedTodoList = withRouter<GraphQLProps>(withRedux(TodoListComponent));

class SkipMutation extends Mutation<SkipStepMutationMutation, SkipStepMutationMutationVariables> {}

class CompleteMutation extends Mutation<
    CompleteStepMutationMutation,
    CompleteStepMutationMutationVariables
> {}

export const TodoList = () => (
    <CompleteMutation mutation={COMPLETE_STEP}>
        {(onCompleteStep) => (
            <SkipMutation mutation={SKIP_STEP}>
                {(onSkip) => (
                    <ConnectedTodoList
                        onCompleteStep={(step) =>
                            onCompleteStep({variables: {step: {id: step.id}}})
                        }
                        onSkip={(step) => onSkip({variables: {step: {id: step.id}}})}
                    />
                )}
            </SkipMutation>
        )}
    </CompleteMutation>
);
